export const SET_USER = 'SET_USER';
export const SET_HOUSES = 'SET_HOUSES';
export const SET_HOUSE = 'SET_HOUSE';
export const SET_FAVOURITE = 'SET_FAVOURITE';
export const SET_LOADING = 'SET_LOADING';
